import { Component, OnInit } from '@angular/core';
import { DialogRef } from "@progress/kendo-angular-dialog";
import {of} from "rxjs";

@Component({
  selector: 'app-kendo-confirmation-dialog',
  templateUrl: './kendo-confirmation-dialog.component.html',
  styleUrls: ['./kendo-confirmation-dialog.component.scss']
})
export class KendoConfirmationDialogComponent implements OnInit {
  title: string;
  question: string;
  furtherInfo: Array<string>;
  selected: string;

  constructor(private dialog: DialogRef) {
  }

  ngOnInit() {
  }

  yes() {
    this.selected = 'Yes';
    this.dialog.close();
  }

  no() {
    this.selected = 'No';
    this.dialog.close();
  }
}
